import { THREAD_MENU_ACTION } from '@/components/SecondaryLeftNavigation/components/threadRowMenuConfig'
import { handleThreadMenuDelete } from './helpers/handleThreadMenuDelete'

/** @param {object} m */
export function createThreadMenuHandler(m) {
  return (thread, actionId) => {
    if (actionId === THREAD_MENU_ACTION.SHARE) {
      m.setThreadShareThread(thread)
      return
    }
    if (actionId === THREAD_MENU_ACTION.PIN_TO_BOARD) {
      m.setPinnedThreadIds((prev) => (prev.includes(thread.id) ? prev : [...prev, thread.id]))
      return
    }
    if (actionId === THREAD_MENU_ACTION.REMOVE_FROM_BOARD) {
      m.setPinnedThreadIds((prev) => prev.filter((id) => id !== thread.id))
      return
    }
    if (actionId === THREAD_MENU_ACTION.DELETE) handleThreadMenuDelete(thread, m)
  }
}
